import ServiceIdentityHeader from './ServiceIdentityHeader';

export default ServiceIdentityHeader;
